module.exports = __webpack_public_path__ + "static/media/dust-labs.d1281aed.png";